const SHA256_HEX = /^[0-9a-f]{64}$/i;

export function normalizePasswordHash(
  raw: string | undefined,
): string | undefined {
  const trimmed = raw?.trim();
  if (!trimmed) return undefined;
  if (!SHA256_HEX.test(trimmed)) {
    throw new Error(
      "VITE_PIRATES_PASSWORD_HASH must be a 64-character SHA-256 hex digest",
    );
  }
  return trimmed.toLowerCase();
}
